import { PRIVATE_HTTP as http } from "../http-common";

const vehiclesAPI = async () => {
  return http().get("/api/v4/users/vehicles");
};

const searchVehicles = async (q: string) => {
  return http().get(`/api/v4/users/vehicles?q=${q}`);
};

const vehicle = async (id: number) => {
  return http().get(`/api/v4/users/vehicles/${id}`);
};

export { vehiclesAPI, searchVehicles, vehicle };
